export default __webpack_public_path__ + "src/images/packages/emily-moon-lodge/51a884c80a79a13b67c2c35647095713-3.jpg";